import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "爆料分类",
    links: [
      { label: "网红黑料", href: "/category/influencer" },
      { label: "明星爆料", href: "/category/celebrity" },
      { label: "独家内幕", href: "/category/exclusive" },
      { label: "每日大赛", href: "/category/daily" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "品牌介绍", href: "/about" },
      { label: "编辑团队", href: "/about#team" },
      { label: "投稿须知", href: "/about#submit" },
      { label: "免责声明", href: "/about#disclaimer" },
    ],
  },
  {
    title: "热门标签",
    links: [
      { label: "911爆料", href: "/search?q=911爆料" },
      { label: "91爆料网", href: "/search?q=91爆料网" },
      { label: "51爆料网", href: "/search?q=51爆料网" },
      { label: "黑料网", href: "/search?q=黑料网" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-flashlight-fill text-background-50 text-sm"></i>
              </div>
              <span
                className="text-lg font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                爆料网
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              整合911爆料与91爆料网核心黑料资源，每日实时追踪网红主播塌房现场、明星反差视频与独家吃瓜内容。
            </p>
            <p className="text-xs text-foreground-400">
              本站内容来源于网络，仅供娱乐参考。
            </p>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-bold text-foreground-400 uppercase tracking-wider mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 爆料网. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400">爆料吃瓜网 | 每日爆料不打烊</span>
          </div>
        </div>
      </div>
    </footer>
  );
}